import { useEffect, useState } from 'react';

import { Option } from '@/common/types';

interface Params {
  options: Option[];
  currentPage: number;
}

const useAccumulatedOptions = ({ options, currentPage }: Params) => {
  const [accumulated, setAccumulated] = useState<Option[]>([]);

  useEffect(() => {
    if (options.length === 0) return;

    if (currentPage === 1) {
      setAccumulated(options);
    } else {
      setAccumulated((prev) => {
        const existingKeys = new Set(prev.map((item) => item.key));
        const newItems = options.filter((item) => !existingKeys.has(item.key));
        return newItems.length > 0 ? [...prev, ...newItems] : prev;
      });
    }
  }, [options, currentPage]);

  return {
    accumulated,
  };
};

export default useAccumulatedOptions;
